import axiosClient from '../libs/axios';

export const getProjects = async () => {
  const response = await axiosClient.get('/projects')
  return response.data
}

export const postProjectsCreate = async (data) => {
  const response = await axiosClient.post('/projects/create', data);
  return response.data;
};

export const postProjectsUpdate = async (slug, data) => {
  const response = await axiosClient.post(`/projects/update/${slug}`, data);
  return response.data;
};

export const postProjectsUploadImage = async (slug, imageFile) => {
  const formData = new FormData();
  formData.append('image', imageFile);
  
  const response = await axiosClient.post(`/projects/upload-image/${slug}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getProjectsSearch = async (data) => {
  const response = await axiosClient.get('/projects/search/' + data.slug);
  return response.data;
};

export const getProjectsTiny = async (data) => {
  const response = await axiosClient.get('/projects/tiny/' + data.slug);
  return response.data;
};

export const getProjectsDash = async (data) => {
  const response = await axiosClient.get('/projects/dash/' + data.slug);
  return response.data;
};

export const getProjectsTeam = async (data) => {
  const response = await axiosClient.get('/projects/team/' + data.slug);
  return response.data;
};

export const getProjectsTeamInvite = async (data) => {
  const response = await axiosClient.get('/projects/team/invite/' + data.slug);
  return response.data;
};

export const getProjectsTimeline = async (data) => {
  const response = await axiosClient.get('/projects/timeline/' + data.slug);
  return response.data;
};

export const postProjectsTimelineSet = async (data) => {
  const response = await axiosClient.post('/projects/timeline/set/' + data.slug, data);
  return response.data;
};

export const postProjectsUserSet = async (data) => {
  const response = await axiosClient.post('/projects/user/set/' + data.slug, data);
  return response.data;
};

export const postProjectsStatusSet = async (data) => {
  const response = await axiosClient.post('/projects/status/set/' + data.slug, data);
  return response.data;
};

// Kullanıcı rolünü değiştir (API'ye göre güncellendi)
export const postProjectsUserRole = async (data) => {
  const response = await axiosClient.post('/projects/user/role/' + data.slug, {
    uid: data.uid,
    role: data.role
  });
  return response.data;
};

export const postProjectsUserDelete = async (data) => {
  const response = await axiosClient.post('/projects/user/delete/' + data.slug, {
    id: data.id
  });
  return response.data;
};

export const postProjectsUserJointo = async (data) => {
  const response = await axiosClient.post('/projects/user/jointo/' + data.slug, data);
  return response.data;
};

export const postProjectTask = async (data) => {
  const response = await axiosClient.post('/projects/task/' + data.slug, { taskid: parseInt(data.taskId) });
  return response.data;
};

export const postProjectsTaskDelete = async (data) => {
  const response = await axiosClient.post('/projects/task/delete/' + data.slug, data);
  return response.data;
};

export const postProjectsTaskNew = async (data) => {
  const response = await axiosClient.post('/projects/task/new/' + data.slug, data);
  return response.data;
};

export const postProjectsTaskEdit = async (data) => {
  const response = await axiosClient.post('/projects/task/edit/' + data.slug, data);
  return response.data;
};

export const postProjectsTaskStatus = async (data) => {
  const response = await axiosClient.post('/projects/task/status/' + data.slug, data);
  return response.data;
};

export const getProjectsTasks = async (data) => {
  const response = await axiosClient.get('/projects/tasks/' + data.slug);
  return response.data;
};

export const postProjectsTasksByStatus = async (data) => {
  const response = await axiosClient.post('/projects/tasks/status/' + data.slug, data);
  return response.data;
};

export const postProjectsTasksByPriority = async (data) => {
  const response = await axiosClient.post('/projects/tasks/priority/' + data.slug, data);
  return response.data;
};

export const postProjectsNotifyAndUpdate = async (data) => {
  const response = await axiosClient.post('/projects/notifyandupdate/', data);
  return response.data;
};

// Kullanıcı İstekleri API'leri
export const getProjectsRequests = async (data) => {
  const response = await axiosClient.get('/projects/requests/' + data.slug);
  return response.data;
};

export const postProjectsRequestApprove = async (data) => {
  const response = await axiosClient.post('/projects/request/approve/' + parseInt(data.requestId), data);
  return response.data;
};

export const postProjectsRequestReject = async (data) => {
  const response = await axiosClient.post('/projects/request/reject/' + parseInt(data.requestId), data);
  return response.data;
};

// Proje İstatistikleri API'si
export const getProjectStatistics = async (slug) => {
  const response = await axiosClient.get(`/projects/statistics/${slug}`);
  return response.data;
};

// Proje Katılım API'si
export const postProjectJoin = async (slug) => {
  const response = await axiosClient.post(`/projects/join/${slug}`);
  return response.data;
};

// Proje Silme API'si
export const deleteProject = async (slug) => {
  const response = await axiosClient.post(`/projects/delete/${slug}`);
  return response.data;
};